import { render } from "./GroupChat.vue?vue&type=template&id=0789ff50"
import script from "./GroupChat.vue?vue&type=script&lang=js"
export * from "./GroupChat.vue?vue&type=script&lang=js"

import "./GroupChat.vue?vue&type=style&index=0&id=0789ff50&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__